export default __webpack_public_path__ + "static/media/P-013.05091f55.png";